module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_arrow-3d0703de91ccfbd68e699554a394d7e9.svg";